
import CustomModal from '../molecule/CustomModal.vue';
import CloseIcon from '../icons/CloseIcon.vue';
import { mapActions } from 'vuex';
export default {
  name: 'PortfolioGuideModal',
  components: { CustomModal, CloseIcon },
  data() {
    return {
      currentSlide: 1,
      slideCount: 7,
      currentDisplayLanguage: this.$i18n.locale,
    };
  },
  computed: {
    bodyText() {
      return this.$t(`portfolio_guide_modal_slide_${this.currentSlide}`);
    },
    imgUrl() {
      return require(`@/assets/img/portfolio-guide-modal-illustration-${this.currentDisplayLanguage}${this.currentSlide}.png`);
    },
    shouldShowBackButton() {
      return this.currentSlide > 1;
    },
    shouldShowOkButton() {
      return this.currentSlide === this.slideCount;
    },
  },
  methods: {
    ...mapActions('modals', ['togglePortfolioGuideModal']),
    handleBack() {
      this.currentSlide = this.currentSlide - 1;
    },
    handleNext() {
      this.currentSlide = this.currentSlide + 1;
    },
    handleCloseModal() {
      this.togglePortfolioGuideModal(false);
    },
  },
};
